import { buildCompactServices } from './pricing.compact.utils';
import * as Pricing from './interfaces';

export const items = [
  buildCompactServices(Pricing.ColumnIdentifer.Customer),
  buildCompactServices(Pricing.ColumnIdentifer.Market),
  buildCompactServices(Pricing.ColumnIdentifer.Enterprise),
];